import React from 'react';
import { NavLink } from 'react-router-dom';
import includes from 'lodash/includes';

import { personaAccountPaths } from '../../../shared/links';
import classes from './NavBar.module.scss';
import { joinClasses } from '../../../shared/utility';

const manageFeaturesLink = props => {
    if (props.match.path === "/persona-file/:id/manage-features" && props.isOwner) {
        return (
            <NavLink
                activeClassName={joinClasses([classes.DropdownMenuItemActive, 'active'])}
                to={props.match.url}
                className={joinClasses(["nav-link dropdown-item", classes.DropdownMenuItem])}>Manage Features
            </NavLink>
        )
    }
    else if (includes(personaAccountPaths, props.match.path) && props.isOwner) {
        return (
            <NavLink
                activeClassName={joinClasses([classes.DropdownMenuItemActive])}
                to={`/persona-file/${props.match.params.id}/manage-features`}
                className={joinClasses(["nav-link dropdown-item", classes.DropdownMenuItem])}>Manage Features
            </NavLink>
        )
    }
    else return null;
}

export default manageFeaturesLink;